<template>
  <div >

<!--    直播简介-->
    <div  class="bgBoxM">
      <div class="bgBoxS">
        <div class="lvIntrodutionTitle">活动简介</div>
        <div class="lvIntrodutionTitle_describe">{{ baseInfo.note }}</div>
        <table class="lvTable">
          <tr class="lvTable_tr" v-for="(item, index) in baseInfo.liveTime">
            <td style="width: 25%; border-style: solid;">{{ toStrStartToStopTime(item.startTime, item.endTime) }}</td>
            <td style="width: 25%; border-style: solid;">{{ item.lecturer }}</td>
            <td style="width: 50%; border-style: solid;">{{ item.topic }}</td>
          </tr>
        </table>
      </div>
    </div>

<!--    直播讲师-->
    <div  class="bgBoxM" v-if="baseInfo.liveLecturer.length!=0">
      <div class="bgBoxS">
        <div class="lvIntrodutionTitle">直播讲师</div>
        <div v-for="(item, index) in baseInfo.liveLecturer">
          <div class="lvTeacherBox">
            <div class="lvlvTeacherImg"><img style="object-fit: contain;" :src= "item.image" alt=""></div>
            <div class="lvlvTeacherIntroduce">
              <div class="lvlvTeacherIntroduceName">{{ item.name }}</div>
              <div class="lvlvTeacherIntroduceWork">{{ item.jobTitle }}</div>
            </div>
          </div>
          <div class="lvIntrodutionTitle_describe">{{ item.note }}</div>
        </div>
      </div>
    </div>

<!--    组织单位-->
    <div  class="bgBoxM" v-if="organizers!=''
                              ||guidancers!=''
                              ||undertakers!=''
                              ||coOrganizers!=''
                              ||supporters!=''
                              ||supportMedias!=''
                              ||technicians!=''">
      <div class="bgBoxS clear-fix">

        <div class="lvIntrodutionTitle">组织单位</div>
        <div class="lvIntrodutionUnit ">
          <!--      主办单位-->
          <div v-if="organizers!=''">
            <div class="lvIntrodutionUnitTitle">主办单位：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ organizers }}</pre></div>
          </div>
          <!--      指导单位-->
          <div v-if="guidancers!=''">
            <div class="lvIntrodutionUnitTitle">指导单位：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ guidancers }}</pre></div>
          </div>
          <!--      承办单位-->
          <div v-if="undertakers!=''">
            <div class="lvIntrodutionUnitTitle">承办单位：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ undertakers }}</pre></div>
          </div>
          <!--      协办单位-->
          <div v-if="coOrganizers!=''">
            <div class="lvIntrodutionUnitTitle">协办单位：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ coOrganizers }}</pre></div>
          </div>
          <!--      支持单位-->
          <div v-if="supporters!=''">
            <div class="lvIntrodutionUnitTitle">支持单位：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ supporters }}</pre></div>
          </div>
          <!--      支持媒体-->
          <div v-if="supportMedias!=''">
            <div class="lvIntrodutionUnitTitle">支持媒体：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ supportMedias }}</pre></div>
          </div>
          <!--      技术支持-->
          <div v-if="technicians!=''">
            <div class="lvIntrodutionUnitTitle">技术支持：</div>
            <div class="lvIntrodutionUnitDetail"><pre>{{ technicians }}</pre></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomOff"></div>
<!--    增加推荐-->
    <!--    推荐信息-->
    <recommend :dailies="baseInfo.articles"></recommend>
  </div>
</template>

<script>
import {utils} from "../../../network/utils";
import {actUtil} from "../../../js/activity/util";
import {apiLive} from "../../../network/app/apiPlatformLive";
import recommend from "../../ recommend/recommend";

export default {
  name: "lvIntroduction",
  components:{
    recommend
  },
  props: {
    isAction: {
      type: Boolean,
      default: false,
    },
    baseInfo: {
      type: Object,
      required: true
    },
  },
  computed:{
    organizers(){
      return this.unitInfo(this.baseInfo.organizers)
    },
    guidancers(){
      return this.unitInfo(this.baseInfo.guidancers)
    },
    undertakers(){
      return this.unitInfo(this.baseInfo.undertakers)
    },
    coOrganizers(){
      return this.unitInfo(this.baseInfo.coOrganizers)
    },
    supporters(){
      return this.unitInfo(this.baseInfo.supporters)
    },
    supportMedias(){
      return this.unitInfo(this.baseInfo.supportMedias)
    },
    technicians(){
      return this.unitInfo(this.baseInfo.technicians)
    },
  },
  data(){
    return {
      count: 10,
      timer: '',
    }
  },
  created() {
    // 创建定时器10s
    this.timer = setInterval(this.intervalCallBack, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods:{
    intervalCallBack(){
      if(this.isAction){
        // this.getPlatformLiveWordsPullDown();
        // this.fingerId = getFingerPrint()
        // console.log("简介++我在线")
        this.onLine()

      }
    },
    toStrStartToStopTime(startTime, endTime){
        return utils.date('H:i', startTime) + "-" + utils.date('H:i', endTime);
    },
    unitInfo(str){
      if((typeof str != "undefined")&&(str.length!=0)){
        return actUtil.jsonToString(str, str.length, "\n")
      }else{
        return ''
      }
    },
    onLine(){
      let obj = {
        'id': this.baseInfo.id,
      }
      apiLive.onLine(obj).then(res=>{
        // console.log(res)
      }).catch(err=>{
      })
    }
  }
}
</script>

<style scoped>
.bottomOff{
  width: 100%;
  height: 40px;
}
.bgBoxM{
  margin: auto;
  margin-top: 60px;
  width: 990px;
  background-color: white;
  /*background-color: snow;*/
  border-radius: 40px;
  box-shadow: 0px 0px 40px #f0f0f0;
  /*padding-top: 40px;*/
  /*padding-bottom: 50px;*/
}
.bgBoxS{
  margin: auto;
  padding: 60px;
  /*width: 90%;*/
  width: 100%;
}
.lvIntrodutionTitle{
  letter-spacing: 2px;
  text-align: center;
  width: 100%;
  height: 50px;
  /*background-color: #ead287;*/
  font-size: 50px;
  line-height: 50px;
  color: #000000;
  font-weight: bolder;
}

.lvIntrodutionTitle_describe{
  margin-top: 50px;
  text-align: left;
  width: 100%;
  /*background-color: #ead287;*/
  font-size: 40px;
  line-height: 60px;
  color: #000000;
  text-indent: 2em;
}
.lvTable{
  margin-top: 30px;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  font-size: 30px;
}
.lvTable_tr{
  height: 100px;
}

.lvTeacherBox{
  width: 100%;
  height: 250px;
  /*background-color: #ead287;*/
  margin-top: 60px;
}
.lvlvTeacherImg{
  float: left;
  width: 250px;
  height: 250px;
  /*background-color: #07c160;*/
  margin-right: 60px;
}
.lvlvTeacherIntroduce{
  float: left;
  width: 550px;
  height: 250px;
  /*background-color: #0c83ae;*/
  overflow: hidden;
}

.lvlvTeacherIntroduceName{
  position: relative;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 40px;
  font-weight: bolder;
  letter-spacing: 4px;
  /*background-color: #0c83ae;*/
}
.lvlvTeacherIntroduceWork{
  position: relative;
  width: 100%;
  font-size: 40px;
  font-weight: normal;
}


.lvIntrodutionUnit
{
  margin-top: 60px;
  text-align: left;
  /*background-color: #ead287;*/
  font-size: 40px;
  line-height: 55px;
  color: #000000;
}
.lvIntrodutionUnitTitle,
.lvIntrodutionUnitDetail{
  float: left;
  margin-bottom: 20px;
}
.lvIntrodutionUnitTitle{
  font-weight: bolder;
  width: 200px;
}
.lvIntrodutionUnitDetail{
  width: 670px;
  overflow-x: hidden;
  word-break: break-all;
  /*background-color: #ead287;*/
  overflow-wrap: break-word;
}

</style>